import { BreadCrumb } from "primereact/breadcrumb";
import { useIntl } from "react-intl";

const Dasboard = () => {
  const intl = useIntl();
  const items = [{ label: intl.formatMessage({ id: "dashboard" }) }];

  return (
    <div>
      <BreadCrumb model={items} home={{ icon: "pi pi-home" }} />
    </div>
  );
};

export default Dasboard;
